import * as Types from 'src/actions/project/interested/get/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import { RootState } from 'src/reducers/RootReducer';
import Person from 'src/entities/Person';
import IndexResponse from 'src/value-objects/IndexResponse';

export interface GetProjectInterestedAttempt extends Action {
  type: Types.GET_PROJECT_INTERESTED_ATTEMPT;
}

export interface GetProjectInterestedSuccess extends Action {
  type: Types.GET_PROJECT_INTERESTED_SUCCESS;
  payload: { projectInterested: Person[], interestedUser: boolean };
}

export interface GetProjectInterestedFailure extends Action {
  type: Types.GET_PROJECT_INTERESTED_FAILURE;
}

export type GetProjectInterestedAction =
  GetProjectInterestedAttempt
  | GetProjectInterestedSuccess
  | GetProjectInterestedFailure;

export interface GetProjectInterestedThunk extends ThunkAction<Promise<GetProjectInterestedAction>, RootState, string> {
}

export const getProjectInterestedAttempt: ActionCreator<GetProjectInterestedAttempt> = () => (
  {
    type: Types.GET_PROJECT_INTERESTED_ATTEMPT
  }
);

export const getProjectInterestedSuccess: ActionCreator<GetProjectInterestedSuccess> = (
  interested: { projectInterested: Person[], interestedUser: boolean }) => (
  {
    type: Types.GET_PROJECT_INTERESTED_SUCCESS,
    payload: interested
  }
);

export const getProjectInterestedFailure: ActionCreator<GetProjectInterestedFailure> = () => (
  {
    type: Types.GET_PROJECT_INTERESTED_FAILURE
  }
);

export const getProjectInterested: ActionCreator<GetProjectInterestedThunk> =
  (id: number, personId: number, personType): GetProjectInterestedThunk => {
    return (dispatch: Dispatch<RootState>): Promise<GetProjectInterestedAction> => {
      dispatch(getProjectInterestedAttempt());
      
      return ApiClient.projectInterested.index({projectId: id})
        .then((response: AxiosResponse<IndexResponse<Person>>): GetProjectInterestedSuccess => {
          const projectInterested: Person[] = response.data.content;
          const interestedUser = (projectInterested!
            .filter(element => element.id === personId)
            .filter(element => element.personType === personType)
            .length > 0);

          return dispatch(getProjectInterestedSuccess({
            projectInterested: projectInterested,
            interestedUser: interestedUser
          }));
        }).catch((): GetProjectInterestedFailure => {
          return dispatch(getProjectInterestedFailure());
        });
    };
  };



// WEBPACK FOOTER //
// ./src/actions/project/interested/get/GetProjectInterested.actions.tsx